<template>
	<v-form
		class="registration-form-step1"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<v-row>
			<v-col cols="12">
				<v-text-field
					class="pt-0 email-field"
					color="red"
					v-model="fields.user_login"
					:error-messages="field_errors.email"
					:rules="rules.email"
					required
					:placeholder="placeHolderLogin"
				/>
			</v-col>
			<v-col cols="12" class="pb-0">
				<v-text-field
					class="pt-0 password-field"
					:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
					:type="showPassword ? 'text' : 'password'"
					v-model="fields.user_password" required
					:rules="rules.password"
					:error-messages="field_errors.password"
					:placeholder="placeHolderPassword"
					@click:append="showPassword = !showPassword"
				/>
			</v-col>
			<v-col cols="12" class="text-center mb-4">
				<v-btn
					class="align-center px-11 py-6 registration-form-step1__submit"
					type="submit"
					v-if="signUpButton"
				>
					{{ signUpButton }}
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>
<script>
import Form from '@/mixins/Form'
import { mapGetters } from 'vuex'
import { ruleEmail, rulePassword, ruleRequired } from '@/utils/rules'

export default {
	mixins: [Form],
	props: {
		categorySettings: {
			type: Object,
			default: null,
		},
		initFields: {
			type: Object,
			default: () => {
			},
		},
	},
	data() {
		return {
			fields: {
				user_login: '',
				user_password: '',
			},
			showPassword: false,
		}
	},
	methods: {
		submitForm() {
			this.$emit('submitStep1', this.fields)
		},
	},
	computed: {
		...mapGetters('settings', ['login']),

		rules() {
			return {
				email: [
					(v) => ruleRequired(v) || 'Field is required.',
					(v) => ruleEmail(v) || 'Invalid email.',
				],
				password: [
					(v) => ruleRequired(v) || 'Field is required.',
					(v) => rulePassword(v) || 'Password must contain a minimum of 5 characters.',
				],
			}
		},
		signUpButton() {
			if (this.categorySettings) {
				return this.categorySettings?.signup_button  || 'Sign Up'
			}
			return null
		},
		placeHolderLogin() {
			const {
				email_title: loginCategoryPlaceHolder,
			} = this.categorySettings || {}
			return loginCategoryPlaceHolder || 'Email'
		},
		placeHolderPassword() {
			const {
				password_title: passwordCategoryPlaceHolder,
			} = this.categorySettings || {}

			return passwordCategoryPlaceHolder || 'Password'
		},
	},
	created() {
		this.fields = this.initFields
	},
}
</script>
<style lang="scss">
.registration-form-step1 {

	&__submit {
		height: 50px !important;
		width: 100%;
		border-radius: 8px;
		font-size: 18px !important;
		font-weight: 700;
		color: #fff !important;
		line-height: 21.94px;
		text-transform: capitalize;
		background-color: var(--button-main-background-color) !important;
	}

	.theme--light.v-input input {
		color: #000;
	}

	.password-field, .email-field {
		input { /*background-color: #4a90e2;*/
			padding-left: 10px;
			font-size: 13px;
			font-weight: 500;
			max-height: 50px;
		}

		.v-input__slot {
			border-bottom: 1px solid rgba(0, 0, 0, 0.6);
		}
	}

	.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
		color: #e5e5e5;
		border-color: #e5e5e5;
	}

	.password-field {
		.v-input__append-inner {
			margin-top: 0;

			.v-input__icon--append {
				.v-icon {
					color: #e5e5e5;
					padding: 30px 0 20px;
				}
			}
		}
	}

	input::placeholder {
		color: #9B9B9B !important;
		opacity: 1;
	}
}
</style>